import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "ai-review-page" }
const _hoisted_2 = {
  key: 1,
  class: "ai-review-card"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  class: "ai-review-card"
}
const _hoisted_5 = {
  key: 3,
  class: "ai-review-card ai-handoff-card"
}
const _hoisted_6 = { class: "ai-handoff-when" }
const _hoisted_7 = {
  key: 0,
  class: "ai-handoff-note"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ai-handoff-kind" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "ai-handoff-save" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "ai-handoff-actions" }
const _hoisted_14 = { class: "ai-handoff-fine" }
const _hoisted_15 = {
  key: 3,
  class: "ai-handoff-error"
}
const _hoisted_16 = {
  key: 4,
  class: "ai-review-card"
}
const _hoisted_17 = {
  key: 5,
  class: "ai-review-card"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "ai-review-card ai-review-bg" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_meeting_review = _resolveComponent("ai-meeting-review")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ai_process_modal = _resolveComponent("ai-process-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.job && _ctx.job.nodeType === 'meeting')
      ? (_openBlock(), _createBlock(_component_ai_meeting_review, {
          key: 0,
          "job-id": _ctx.job.id
        }, null, 8, ["job-id"]))
      : (_ctx.state == 'processing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "ai-review-orb" }, null, -1)),
            _createElementVNode("h2", null, "Your " + _toDisplayString(_ctx.typeLabel.toLowerCase()) + " draft is still being generated", 1),
            (_ctx.job && _ctx.job.stage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.job.stage) + "...", 1))
              : _createCommentVNode("", true),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, "This page will update automatically — or come back later using the link in your email.", -1))
          ]))
        : (_ctx.state == 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Something went wrong", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1),
              _createVNode(_component_router_link, { to: "/playbook/home" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Back to Ironbook", -1)
                ]))]),
                _: 1
              })
            ]))
          : (_ctx.state == 'handoff')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.job.handoffToMe ? 'A screen recording from ' + (_ctx.job.handoffFrom || 'a colleague') : 'Your screen recording, sent to ' + (_ctx.job.handoffTo || 'a colleague')), 1),
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode("Recorded " + _toDisplayString(_ctx.recordedWhen), 1),
                  (!_ctx.job.handoffToMe)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · waiting for " + _toDisplayString(_ctx.job.handoffTo || 'them') + " to build it", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.job.note)
                  ? (_openBlock(), _createElementBlock("blockquote", _hoisted_7, _toDisplayString(_ctx.job.note), 1))
                  : _createCommentVNode("", true),
                (_ctx.job.recordingUrl)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("video", {
                        class: "ai-handoff-video",
                        controls: "",
                        playsinline: "",
                        preload: "metadata",
                        src: _ctx.recordingUrl
                      }, null, 8, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ai-handoff-kind-label" }, "Build a", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildTypes, (t) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: t.key,
                            class: _normalizeClass(["ai-handoff-kind-pill", { 'ai-handoff-kind-on': _ctx.buildType == t.key }]),
                            onClick: ($event: any) => (_ctx.buildType = t.key)
                          }, _toDisplayString(t.label), 11, _hoisted_10))
                        }), 128))
                      ]),
                      _createElementVNode("label", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saveVideo) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.saveVideo]
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("span", {
                          class: "ai-handoff-switch",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Save the video with it", -1)),
                          _createElementVNode("em", null, _toDisplayString(_ctx.saveVideo ? 'The recording is added to Videos next to the new ' + _ctx.buildNoun + '.' : 'The recording is only used to write the draft, then deleted.'), 1)
                        ])
                      ]),
                      (_ctx.job.handoffToMe)
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 0,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buildNote) = $event)),
                            rows: "3",
                            class: "ai-handoff-build-note",
                            placeholder: 'Anything the Forge should know before it writes the ' + _ctx.buildNoun + ' (optional)'
                          }, null, 8, _hoisted_12)), [
                            [_vModelText, _ctx.buildNote]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ai-btn", { 'disable-button': _ctx.acting }]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.build()))
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.acting == 'build' ? 'Starting…' : 'Build the ' + _ctx.buildNoun + ' with the Forge'), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["ai-btn ai-btn-ghost", { 'disable-button': _ctx.acting }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.discard()))
                        }, _toDisplayString(_ctx.acting == 'discard' ? 'Discarding…' : 'Discard the recording'), 3)
                      ]),
                      _createElementVNode("p", _hoisted_14, [
                        _cache[13] || (_cache[13] = _createTextVNode("Build sends the recording to the Forge under your name. The draft comes back here for you to review", -1)),
                        (_ctx.saveVideo)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(", and the recording is kept as the " + _toDisplayString(_ctx.buildNoun) + "'s video", 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        _cache[14] || (_cache[14] = _createTextVNode(".", -1))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "ai-review-orb" }, null, -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("p", null, "Saving the recording… this page updates on its own.", -1))
                    ], 64)),
                (_ctx.actionError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.actionError), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.state == 'discarded')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[18] || (_cache[18] = _createElementVNode("h2", null, "This recording was discarded", -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("p", null, "Nothing was built from it. Record it again from the Forge if it is still needed.", -1)),
                  _createVNode(_component_router_link, { to: "/ai-hub" }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("Back to the Forge", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : (_ctx.state == 'consumed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.job && _ctx.job.targetSlug ? 'This update was already applied' : 'This draft was already turned into a ' + _ctx.typeLabel.toLowerCase()), 1),
                    (_ctx.job && _ctx.job.createdSlug)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, "You can keep working on it in the editor."))
                      : _createCommentVNode("", true),
                    (_ctx.job && _ctx.job.createdSlug)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: _ctx.editRoutes[_ctx.nodeType] + _ctx.job.createdSlug
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Open the " + _toDisplayString(_ctx.typeLabel.toLowerCase()), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: "/playbook/home"
                        }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("Back to Ironbook", -1)
                          ]))]),
                          _: 1
                        })),
                    (_ctx.job && _ctx.job.videoSlug)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 3,
                          to: '/playbook/' + _ctx.job.videoSlug,
                          style: {"margin-left":"16px"}
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("Watch the video", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.state == 'complete')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[26] || (_cache[26] = _createElementVNode("h2", null, "AI Draft Review", -1)),
                        (_ctx.job.targetSlug && _ctx.job.mode == 'extend')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                              _cache[22] || (_cache[22] = _createTextVNode("These additions go onto ", -1)),
                              _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.job.targetName || _ctx.job.targetSlug) + "\"", 1),
                              _cache[23] || (_cache[23] = _createTextVNode(" — accepting saves them as a draft awaiting approval.", -1))
                            ]))
                          : (_ctx.job.targetSlug)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                _cache[24] || (_cache[24] = _createTextVNode("This draft ", -1)),
                                _createElementVNode("strong", null, "updates \"" + _toDisplayString(_ctx.job.targetName || _ctx.job.targetSlug) + "\"", 1),
                                _cache[25] || (_cache[25] = _createTextVNode(" — accepting saves it onto that process as a draft awaiting approval.", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_22, "Review the generated " + _toDisplayString(_ctx.typeLabel) + " below, adjust the details the AI filled in, and create it.", 1))
                      ]),
                      _createVNode(_component_ai_process_modal, {
                        mode: "generate",
                        "node-type": _ctx.job.nodeType || 'process',
                        "create-mode": !_ctx.job.targetSlug,
                        busy: _ctx.creating,
                        "accept-label": _ctx.job.targetSlug ? 'Save Update as Draft' : 'Create ' + _ctx.typeLabel,
                        "initial-draft": _ctx.job.draft,
                        "initial-note": _ctx.job.note,
                        "job-id": _ctx.job.id,
                        onAccept: _ctx.onAccept,
                        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/playbook/home')))
                      }, null, 8, ["node-type", "create-mode", "busy", "accept-label", "initial-draft", "initial-note", "job-id", "onAccept"])
                    ], 64))
                  : _createCommentVNode("", true)
  ]))
}